// See
// dev/dashboard/java/src/com/visiblethread/utils/RegexUtils.java
// for the Java Version of the wildcard regex-a-like.
export const convertWildcardToRegex = (name = "") => {
  let term = name
    .replace("*", "\\w*")
    .replace("?", "\\w")
    .replace("[!", "[^")
    .replace("[", "[")
    .replace("]", "]")
    .replace("#+", "(\\d)+")
    .replace("#", "(\\d)");

  if (
    term.match("^\\b.*") ||
    term.startsWith("\\w") ||
    term.startsWith("(\\d)")
  ) {
    term = "\\b" + term;
  }

  if (
    term.match(".*\\b$") || // NOSONAR javascript:S5852 - .* is a single flat greedy quantifier with no nested structure; \b is a zero-width assertion checked once per backtrack step — worst-case backtracking is O(n) linear.
    term.endsWith("\\w*") ||
    term.endsWith("(\\d)") ||
    term.endsWith("(\\d)+")
  ) {
    // Handy \\w and \\d end in word characters w and d
    term = term + "\\b";
  }
  return new RegExp(term, "gi");
};

export const getRegexByValue = (value = "", caseSensitive = false) => {
  const escapedValue = value
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/\s{1,10000}/, "[\\s]+");
  const flags = caseSensitive ? "g" : "gi";
  const startsWithWord = /^\w/.test(value);
  const endsWithWord = /\w$/.test(value);

  // Build pattern with conditional word boundaries
  let pattern = "";
  pattern += startsWithWord ? "\\b" : "(?<=^|\\W)";
  pattern += `(${escapedValue})`;
  pattern += endsWithWord ? "\\b" : "(?=$|\\W)";

  return new RegExp(pattern, flags);
};

export const getRegexByTerm = (term) => {
  const { caseSensitive, regex, name, wildcard } = term;
  const flags = caseSensitive ? "g" : "gi";
  if (wildcard) {
    return convertWildcardToRegex(name);
  }

  if (regex) {
    return new RegExp(name, flags);
  }

  return getRegexByValue(name, caseSensitive);
};

export const isValidNumber = (value) => {
  return typeof value === "string" && !/^\d+$/.test(value.trim());
};
